import {  Card, Col, Input, message, Pagination, Row, Select, Typography } from "antd";
import React from "react";
import { connect } from "react-redux";
import Table from "../Table";

import { cityWiseCount, getFranchiseRequest } from "../../RestServices/authService";
import DeleteCompanyRequest from "../UiElements/DeleteCompanyRequest";
import EditFranchiseRequest from "../UiElements/DeleteCompanyRequest/editFranchiseRequest";
import { citiesList } from "../../shared";

const {Option} = Select

// LIKE", "CLAP", "ANGRY"
const columns = [
  {
    Header: (
      <div>
        <p style={{ margin: 0, padding: 0 }}>Sr.</p>
        <p style={{ margin: 0, padding: 0, color: "black" }}># Index</p>
      </div>
    ),
    accessor: "_id",
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Contact",
    accessor: "contact",
  },
  {
    Header: "Occupation",
    accessor: "occupation",
  },
  {
    Header: (
      <div>
        <p style={{ margin: 0, padding: 0 }}>Business</p>
        <p style={{ margin: 0, padding: 0, color: "black" }}>Experience</p>
      </div>
    ),
    accessor: "businessExp",
  },
  {
    Header: (
      <div>
        <p style={{ margin: 0, padding: 0 }}>Area</p>
        <p style={{ margin: 0, padding: 0, color: "black" }}>Experience</p>
      </div>
    ),
    accessor: "areaExp",
  },
  {
    Header: "Willing to Invest",
    accessor: "invest",
  },
  {
    Header: "Best Contact Time",
    accessor: "contactTime",
  },
  {
    Header: "City",
    accessor: "address",
  },
  {
    Header: "Action",
    accessor: "action",
  },
 
];

class FranchaseRequest extends React.Component {
  constructor() {
    super();
    this.state = {
      franchises: [],
      totalPages: 0,
      currentPage: 1,
      query: "",
      editToBe:"",
      deleteModal: false,
      selectedCity: "",
      cities:[]
    };
  }

  
  deleteModalToggle = () =>
    this.setState({ deleteModal: !this.state.deleteModal });


  getArticles = async (pageNo) => {
    try {
      const data = await getFranchiseRequest(
        this.props.Auth.user.token, {pageNo, query:this.state.query, city:this.state.selectedCity}
      );
      const franchises = data.docs.map((franchise, index) => ({
        _id: (
          <div>
            <p>{index + 1}</p>
            {/* Add any timestamp info here if you have it */}
          </div>
        ),
        name: (
          <Typography.Text style={{ fontWeight: "bold" }}>
            {franchise.name}
          </Typography.Text>
        ),
        contact: (
          <Typography.Text>{franchise.contact}</Typography.Text>
        ),

        email: (
          <Typography.Text>{franchise.email||"N/A"}</Typography.Text>
        ),
        occupation: (
          <Typography.Text>{franchise.occupation}</Typography.Text>
        ),
        businessExp: (
          <div>
            <Typography.Text>{franchise.businessExp}</Typography.Text>
            {franchise.businessExpOther && (
              <Typography.Text type="secondary">
                {" "}
                ({franchise.businessExpOther})
              </Typography.Text>
            )}
          </div>
        ),
        areaExp: (
          <div>
            <Typography.Text>{franchise.areaExp}</Typography.Text>
            {franchise.areaExpOther && (
              <Typography.Text type="secondary">
                {" "}
                ({franchise.areaExpOther})
              </Typography.Text>
            )}
          </div>
        ),
        invest: (
          <Typography.Text>{franchise.invest}</Typography.Text>
        ),
        contactTime: (
          <Typography.Text>{franchise.contactTime}</Typography.Text>
        ),
       
        address: (
          <div style={{ maxWidth: "300px" }}>
            
            <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
              {franchise.city}
            </Typography.Text>
          </div>
        ),
       
        action: (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            {" "}

            <EditFranchiseRequest
            
            deleteModalFuc={async() => {
                this.deleteModalToggle(); 

                setTimeout(async() => {
                  await this.getArticles(this.state.currentPage)
                  
                }, 1000);
            }}
            franchise={franchise} />
      <br />
        
            <DeleteCompanyRequest
              deleteModalFuc={() => {
                this.deleteModalToggle(); 
              }}
              franchise={franchise} 
            />
          </div>
        ),
      }));
      this.setState({
        franchises,
        totalPages: data?.totalPages
      });
    } catch (err) {
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };
 
  onEditClick = (franchise) => {
    this.setState({
      editToBe:franchise
    })


  }
 
  getCitiesCount = async() => {
    try {
      const { data } = await cityWiseCount()
      this.setState({
        cities:data
      })
    } catch (err) {
      
    }
  }
componentDidMount() {
  this.getArticles();
  this.getCitiesCount()
  
}
  
    onPageChange = (page) => {
      this.setState({ currentPage: page }, () => {
        this.getArticles(this.state.currentPage);
      });
    };
  

  render() {
    const {
      franchises,
      totalPages,
      currentPage,
 
    } = this.state;

    const { Title } = Typography;

    return (
      <div>
       
          <>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="p-0.5 md:p-5">
                  <Card>
                    <div className="flex-between">
                      <div style={{ width: "100%" }}>
                        <Row gutter={[12, 12]}>
                          <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                            <div className="flex-col">
                              <Title level={2} className="mb-0 text-primary" style={{ height: "50px", lineHeight: "50px" }}>Franchase Request</Title>
                            </div>
                        </Col>
                        
                        <Col md={5}>
                        <div className="flex-col ">
                          <div className="">
                              <Input value={this.state.query} onChange={(e) => {
                                debugger
                                this.setState({
                                  query:e.target.value
                                },()=>this.getArticles(1))
                           }} style={{marginTop:"10px", width:"100%"}} placeholder="Search Request" />
                          </div>
                        </div>
                      </Col>
                      <Col md={5}>
                       
                      <Select
        placeholder="Select City"
        style={{ width: '100%', marginTop: "10px" }}
        value={this.state.selectedCity || undefined}
        onChange={(value) => {
          this.setState({
            selectedCity: value
          }, () => this.getArticles(1)) // Fixed: Arrow function with callback
        }}
        allowClear
        showSearch
        filterOption={(input, option) => {
          // Fixed: Better filter logic for custom option content
          const cityName = option.key || '';
          return cityName.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
      >
        {this.state.cities.map((city) => (
          <Option 
            key={city._id || city.city} 
            value={city._id || city.city}
          >
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center' 
            }}>
              <span>{city._id || city.city}</span>
              <span style={{ 
                color: '#666', 
                fontSize: '12px',
                marginLeft: '8px',
                backgroundColor: '#f0f0f0',
                padding: '2px 6px',
                borderRadius: '10px'
              }}>
                {city.count}
              </span>
            </div>
          </Option>
        ))}
      </Select>
                          </Col>
                        </Row>
                      </div>
                     
                    </div>
                  </Card>
                </div>
              </Col>

              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="p-0.5 md:p-5">
                  <Table
                    onRowClick={this.rowClickHandler}
                    data={franchises}
                    columns={columns}
                    
                  />
                </div>
            </Col>
            
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className="flex-center p-0.5 md:p-5">
              <div>
                <Pagination
                  current={currentPage}
                  total={totalPages}
                  onPageChange={this.onPageChange}
                />
              </div>
            </div>
          </Col>
            </Row>
          </>
      
      </div>
    );
  }
}
const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});
export default connect(mapStateToProps)(FranchaseRequest);
